module.exports = __webpack_public_path__ + "static/media/landing_pattern_bg_household.fd14153e.png";